import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule, LazyAction } from 'owa-bundling';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "SearchActions"*/ './lazyIndex'),
    { name: 'SearchActions' }
);

//VSO#35181 remove clearSearchBox from lazy, is exported as an action above
export const lazyClearSearchBox: LazyImport<typeof lazyIndex.clearSearchBox, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.clearSearchBox);
export const lazyEndSearchSession: LazyImport<
    typeof lazyIndex.endSearchSession,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.endSearchSession);

export const lazyOnBackspacePressedSearchInput: LazyImport<
    typeof lazyIndex.onBackspacePressedSearchInput,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.onBackspacePressedSearchInput);

export const lazyOnDownArrowPressedSearchInput: LazyImport<
    typeof lazyIndex.onDownArrowPressedSearchInput,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.onDownArrowPressedSearchInput);

export const lazyOnRightArrowPressedSearchInput: LazyImport<
    typeof lazyIndex.onRightArrowPressedSearchInput,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.onRightArrowPressedSearchInput);

export const lazyOnLeftArrowPressedSearchInput: LazyImport<
    typeof lazyIndex.onLeftArrowPressedSearchInput,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.onLeftArrowPressedSearchInput);

export const lazyOnUpArrowPressedSearchInput: LazyImport<
    typeof lazyIndex.onUpArrowPressedSearchInput,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.onUpArrowPressedSearchInput);

export const lazyRemoveSuggestionPillFromSearchBox: LazyImport<
    typeof lazyIndex.removeSuggestionPillFromSearchBox,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeSuggestionPillFromSearchBox);

export const lazySetIsSuggestionsDropdownVisible: LazyImport<
    typeof lazyIndex.setIsSuggestionsDropdownVisible,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.setIsSuggestionsDropdownVisible);

export const lazySetShowSearchBoxInCompactMode: LazyImport<
    typeof lazyIndex.setShowSearchBoxInCompactMode,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.setShowSearchBoxInCompactMode);

export const lazyUpdateIsSuggestionSetComplete: LazyImport<
    typeof lazyIndex.updateIsSuggestionSetComplete,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.updateIsSuggestionSetComplete);

export const lazySetSpellerData: LazyImport<typeof lazyIndex.setSpellerData, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.setSpellerData);

export const lazyResetSuggestionsQuickActionsMutator: LazyAction<
    typeof lazyIndex.resetSuggestionsQuickActionsMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.resetSuggestionsQuickActionsMutator);

export const lazySetEntityRecognitionData: LazyAction<
    typeof lazyIndex.setEntityRecognitionDataMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setEntityRecognitionDataMutator);
